import { render, staticRenderFns } from "./printDocument80mm.vue?vue&type=template&id=a8fa2a72&"
import script from "./printDocument80mm.vue?vue&type=script&lang=js&"
export * from "./printDocument80mm.vue?vue&type=script&lang=js&"
import style0 from "./printDocument80mm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../Users/Mac/Desktop/Code/permtang/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports